import zh_CN from './zh_CN/index'
import en from './en/index'

import * as $var from '@/utils/variables'

export default {
  [$var.LangDir.ZHCN]: zh_CN,
  [$var.LangDir.EN]: en,
}